export enum ModelEnum {
  GENERAL_QUALITY = 'General_quality',
}
